import { useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import QrCode2RoundedIcon from '@mui/icons-material/QrCode2Rounded';
import '../accountTheme.css';
import './DepositScreen.css';

const AMOUNTS = ['100', '500', '1000', '2000', '5000', '10000'];
const MIN = 100;
const MAX = 50000;

function DepositScreen({ user, onBack, onOpenUpi }) {
  const [amountInput, setAmountInput] = useState('500');
  const balance = user?.walletBalance ?? 0;

  const amount = Number(amountInput || 0);
  const valid = Number.isFinite(amount) && amount >= MIN && amount <= MAX;

  return (
    <Box className="bz-page deposit-page">
      <Box className="bz-topbar">
        <IconButton size="small" onClick={onBack} className="bz-back-btn">
          <ArrowBackIosNewRoundedIcon fontSize="small" />
        </IconButton>
        <Typography className="bz-topbar__title">Deposit</Typography>
        <Box sx={{ width: 32 }} />
      </Box>

      <Box className="bz-scroll">
        <Box className="bz-balance-hero deposit-balance-hero">
          <Typography className="bz-balance-label">Current balance</Typography>
          <Typography className="bz-balance-value" style={{ fontSize: '1.6rem' }}>
            ₹{balance.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
          </Typography>
        </Box>

        <Typography className="bz-section-title">Payment method</Typography>
        <Box className="bz-card deposit-method-card">
          <QrCode2RoundedIcon sx={{ fontSize: 36, color: '#4ade80' }} />
          <Box>
            <Typography className="deposit-method-title">UPI QR</Typography>
            <Typography className="deposit-method-sub">Instant deposit via UPI</Typography>
          </Box>
        </Box>

        <Typography className="bz-section-title">Select amount</Typography>
        <Box className="bz-card">
          <Box className="bz-amount-grid">
            {AMOUNTS.map((a) => (
              <button
                key={a}
                type="button"
                className={`bz-amount-chip ${amountInput === a ? 'selected' : ''}`}
                onClick={() => setAmountInput(a)}
              >
                ₹{Number(a).toLocaleString('en-IN')}
              </button>
            ))}
          </Box>
          <Box className="bz-input-wrap">
            <Typography sx={{ color: '#4ade80', fontWeight: 800, fontSize: '1.2rem' }}>₹</Typography>
            <input
              value={amountInput}
              onChange={(e) => setAmountInput(e.target.value.replace(/[^\d]/g, ''))}
              placeholder={`${MIN} - ${MAX.toLocaleString('en-IN')}`}
              inputMode="numeric"
            />
          </Box>
          <Typography className="deposit-hint">
            Min ₹{MIN} · Max ₹{MAX.toLocaleString('en-IN')}
          </Typography>
        </Box>

        <Typography className="bz-section-title">Terms &amp; Conditions</Typography>
        <Box className="bz-card deposit-note">
          <Typography className="deposit-note-title">Please read before continuing</Typography>
          <Typography className="deposit-note-line">• Minimum add amount is ₹100</Typography>
          <Typography className="deposit-note-line">• Transfer the exact amount shown on the next screen</Typography>
          <Typography className="deposit-note-line">• Enter correct 12-digit UTR after payment</Typography>
          <Typography className="deposit-note-line">• If UTR is wrong, we are not responsible for failed credit</Typography>
          <Typography className="deposit-note-line">• Repeated wrong UTR submissions may block your ID</Typography>
        </Box>
      </Box>

      <Box className="bz-bottom-bar">
        <button
          type="button"
          className="bz-primary-btn"
          disabled={!valid}
          onClick={() => valid && onOpenUpi?.(amount)}
        >
          Continue · ₹{valid ? amount.toLocaleString('en-IN') : '—'}
        </button>
      </Box>
    </Box>
  );
}

export default DepositScreen;
